module.exports = {
  type: 'stl',
  id: 'part',
  icon: 'table',
  title: 'ProjectDetails.stlUpload',

  requires: 1,
};
